<template>
  <table class="jb-table">
    <thead>
      <tr>
        <th
          v-for="(header, headerIndex) in headers"
          :key="headerIndex"
          :class="{
            _filterable: !!$slots[`filter.${header.key}`],
            _active: sortingKey === header.key,
            _reverse: sortingKey === header.key && sortingDesc
          }"
          :style="{
            width: header.width,
            textAlign: header.align
          }"
          @click="toggleFilterWindow(header.key, $event)"
        >
          <div class="jb-table__flex-wrapper">
            <span>{{ header.title }}</span>
            <div
              class="jb-table__icon-wrapper"
              @click="toggleSort(header.key)"
            >
              <BaseSvg name="ico-arrow" />
            </div>

            <div
              v-if="openedFilteringWindowFor === header.key"
              class="jb-table__modal"
            >
              <slot
                v-bind="{ header, headerIndex }"
                :name="`filter.${header.key}`"
              />
            </div>
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(item, itemIndex) in sortedAndFilteredItems"
        :key="itemIndex"
      >
        <td
          v-for="(header, headerIndex) in headers"
          :key="headerIndex"
          :style="{ textAlign: header.align }"
        >
          <slot
            v-bind="{ item, itemIndex, header, headerIndex }"
            :name="`item.${header.key}`"
          >
            {{ item[header.key] }}
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    name: 'AccountBalanceTable',

    props: {
      items: {
        type: Array,
        required: true
      },
      headers: {
        type: Array,
        required: true
      },
      filters: {
        type: Object
      }
    },

    data: () => ({
      sortingKey: null,
      sortingDesc: false,
      openedFilteringWindowFor: null
    }),

    computed: {
      sortedAndFilteredItems() {
        const header = this.headers.find((f) => f.key === this.sortingKey);

        return this.filteredItems.slice().sort((header || {}).sort || ((a, b) => {
          if (!this.sortingKey) return 0;

          let result = 0;
          let aValue = a[this.sortingKey];
          let bValue = b[this.sortingKey];

          if (header.sortKey) {
            if (aValue) aValue = aValue[header.sortKey];
            if (bValue) bValue = bValue[header.sortKey];
          }

          if (typeof aValue === 'string' || typeof bValue === 'string') {
            result = String(aValue).localeCompare(bValue);
          }
          else if (typeof aValue === 'number' || typeof bValue === 'number') {
            result = aValue - bValue;
          }

          if (!this.sortingDesc) result *= -1;
          return result;
        }));
      },

      filteredItems() {
        return this.items.filter((item) => {
          for (const key in this.filters) {
            const filter = this.filters[key];
            const type = filter.type || 'include';

            switch (type) {
              case 'include': {
                if (!item[key] && filter.items.length) return false;

                for (const filterItem of filter.items) {
                  const equalsInObject = filterItem.key && String(filterItem.data[filterItem.key]) === String(item[key][filterItem.key]);
                  const equalsAnObject = !filterItem.key && String(filterItem.data) === String(item[key]);

                  if (equalsInObject || equalsAnObject) {
                    return true;
                  }
                }

                if (filter.items.length) return false;
                break;
              }

              default:
                console.log('Undefined filtering type');
            }
          }

          return true;
        });
      }
    },

    methods: {
      toggleSort(key) {
        if (this.sortingKey === key) {
          if (this.sortingDesc) {
            this.sortingKey = null;
            this.sortingDesc = false;
            return;
          }

          this.sortingDesc = true;
          return;
        }

        this.sortingKey = key;
        this.sortingDesc = false;
      },

      toggleFilterWindow(key, e) {
        let element = e.target;
        do {
          if (element.classList.contains('jb-table__modal')) return;
          if (element.classList.contains('jb-table__icon-wrapper')) return;
          element = element.parentElement;
        }
        while(element);

        if (!this.$slots[`filter.${key}`]) return;

        if (this.openedFilteringWindowFor === key) {
          this.openedFilteringWindowFor = null;
          return;
        }

        this.openedFilteringWindowFor = key;
      }
    }
  };
</script>
